import { embla } from "javascripts/webpage/embla";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelectorAll("#js-rich-content, #js-hotels-theme")) {
    return;
  }
  embla("js-embra-cover-image", { arrows: false, autoplay: true });
  embla("js-embla-hotel-image", { dots: true });
});
